import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { stroke: true },
  },
});

type BackIconProps = SvgProps & {
  className?: string;
  pathClassName?: string;
};

function BackIcon({
  className,
  pathClassName = "stroke-teachLoop-textPrimary",
  ...props
}: BackIconProps) {
  return (
    <Svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
      className={className}
    >
      <Path
        d="M4 12h16"
        stroke="#000"
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        className={pathClassName}
      />
      <Path
        d="M11.032 4.34L4.46 10.911a1.53 1.53 0 000 2.176l6.572 6.573"
        stroke="#000"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={pathClassName}
      />
    </Svg>
  );
}

export default BackIcon;
